import { FirebaseTasks, FirestoreRef } from './index'

const GeoPoint = FirestoreRef.GeoPoint

const Timestamp = FirestoreRef.Timestamp

const tasksDb = () => {

  const add = (mapper, task) => {
    const mappedTask = mapper(task)
    mappedTask.createdAt = Timestamp.fromDate(new Date())
    return FirebaseTasks.add(mappedTask)
  }

  const update = (taskId, delta) => {
    if (delta.expire)
      delta.expire = Timestamp.fromDate(delta.expire)

    if (delta.geolocation) {
      let [lat, long] = delta.geolocation.split(',')
      delta.geolocation = new GeoPoint(parseFloat(lat.trim()), parseFloat(long.trim()))
    }

    return FirebaseTasks.doc(taskId).update(delta)
  }

  const findOne = async (taskId) => {
    const doc = await FirebaseTasks.doc(taskId).get()
    const task = doc.data()
    task.id = doc.id
    task.geolocation = (task.geolocation) ? `${task.geolocation.latitude},${task.geolocation.longitude}` : ''
    task.expire = (task.expire) ? task.expire.toDate() : ''
    return task
  }

  const findAll = ({projectId=null}) => {
    let query = FirebaseTasks.orderBy('title').orderBy('createdAt')
    if (projectId)
      query = query.where('projectId', '==', projectId)
    return query
  }

  return Object.freeze({
    add,
    findOne,
    findAll,
    update
  })
}

const Tasks = tasksDb()

export { GeoPoint, Timestamp, Tasks }
